import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useProfile } from "../common/useProfile";


export default function ErroPage(){
    const location = useLocation();
    const state = location.state;
    const prof = useProfile();

    console.log( state )

    function MontaErro401(){
        if( !state) return;
        if( !state.erro) return ;
        if( state.erro.status !== 401) return ;

        return (
            <Stack>
                <Typography variant="h6" gutterBottom color="error">Recurso não autorizado: </Typography>
                <Typography variant="subtitle1" gutterBottom>{state.path}</Typography>

                
                {!prof.isOk && <Typography variant="subtitle1" gutterBottom>Efetue login no sistema para acessar recursos restrito:
                <a href="/login"> LOGIN</a> </Typography>}
            </Stack>
        )
    }

    function MontaErro500(){
        if( !state) return;
        if( !state.erro) return ;
        if( state.erro.status !== 500) return ;

        return (
            <Stack>
                <Typography variant="h6" gutterBottom color="error">Erro interno: </Typography>
                <Typography variant="subtitle1" gutterBottom>{state.erro.statusText}</Typography>

            </Stack>
        )
    }

    return (
        <Container maxWidth="md" sx={{m:5}} >
            <Paper sx={{p:2}}>
                <Typography align="center" variant="h5" gutterBottom >Erro na requisição</Typography>

                <MontaErro401 />
                <MontaErro500 />

                {state && state.path && <Box component="section" sx={{ p: 2, border: '1px dashed grey' }}>
                    Voltar para a pagina original: <a href={state.path} > {state.path}</a>
                </Box> }
            </Paper>
        </Container>

    );
}